import { GlobalResponseObject } from "../global-response-object";
import { SoComparisonDetails } from "./so-comparison-details";

export class SoComparisonDetailsResponse extends GlobalResponseObject {
    data?: SoComparisonDetails[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SoComparisonDetails[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}